// extracted by mini-css-extract-plugin
export default {"camps-container":"styles_camps-container__N6KSc"};